export default __webpack_public_path__ + "static/media/banner.194f5306.jpg";